<div class="filter-footer-wrapper">
    <div class="separator"></div>
    <div class="filter-footer-buttons-wrapper">

        <button type="button"
                class="btn-secondary filter-footer-clear-button"
                [attr.data-cy]="filterName + '-clear-button'"
                (click)="clearClick.emit()">Clear
        </button>
        <button type="button"
                class="btn-primary filter-footer-apply-button"
                [attr.data-cy]="filterName + '-apply-button'"
                (click)="applyClick.emit()">Apply
        </button>
    </div>
</div>